.redBackground {
	background-image: url(image/pinkGradient.svg);
	background-repeat: no-repeat;
}

.purpleBackground {
	background-image: url(image/purpleGradient.svg);
	background-repeat: no-repeat;
}

.navyBackground {
	background-image: url(image/navyGradient.svg);
	background-repeat: no-repeat;
}

.blueBackground {
	background-image: url(image/blueGradient.svg);
	background-repeat: no-repeat;
}

.sectionCardTitle {
	font-size: 15px;
	font-weight: 500;
	text-align: left;
}

.sectionCardNumber {
	font-size: 24px;
	font-weight: 600;
	line-height: 1.4;
	text-align: left;
}

.changeNumber {
	font-size: 14px;
	font-weight: 500;
	line-height: 1.6;
	text-align: left;
	border-radius: 15px;
	padding: 5px;
}

.increaseNumber {
	color: #008400;
	background-color: #eafbf2;
}

.decreaseNumber {
	color: #b40030;
	background-color: #f9e6eb;
}

.noChangeNumber {
	color: #000000;
	background-color: #e6e8e7;
}

.sr-only {
	position: absolute;
	top: 0;
	left: 0;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	clip-path: inset(50%);
	white-space: nowrap;
	border: 0;
}

.exportButton {
	width: max-content;
	height: auto;
}

.exportButton svg path {
	/* Override core button filling icon*/
	fill: unset !important;
}

.exportButton:hover svg path,
.exportButton:focus-visible svg path {
	stroke: white;
}

div.exportRow {
	margin: 0 0 8px;
	align-items: center;
	display: grid;
	grid-template-columns: 1fr 5fr;
}

div.exportRow.error {
	align-items: start;
}

p.exportRowHeader {
	font-weight: 700;
	font-size: 18px;
}

p.exportReportDescription {
	color: #6f6f6f;
	margin-bottom: 16px;
}

div.emailTextField {
	height: fit-content;
}

div.tabsContainer {
	width: max-content;
	max-width: 100%;
	margin-left: auto;
}

.reportTable:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
}

@media screen and (max-width: 800px) {
	div.tabsContainer {
		width: 100%;
	}
}